/**
 * Operational access API error codes from backend.
 * Align: backend/src/config/operationalAccess.ts
 */

export const OPERATIONAL_ACCESS_ERROR = {
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  ACCOUNT_REJECTED: 'ACCOUNT_REJECTED',
  ACCOUNT_INACTIVE: 'ACCOUNT_INACTIVE',
  ACCOUNT_NOT_READY: 'ACCOUNT_NOT_READY',
  PASSPORT_ONBOARDING_ONLY: 'PASSPORT_ONBOARDING_ONLY'
} as const;

/** B2 user-facing messages — mirror backend OPERATIONAL_ACCESS_USER_MESSAGE. */
export const OPERATIONAL_ACCESS_USER_MESSAGE = {
  PENDING_APPROVAL:
    'Your account is pending approval. You will receive an email when you are approved.',
  ACCOUNT_REJECTED:
    'This account has been rejected. Contact support for more information.',
  ACCOUNT_INACTIVE: 'This account is inactive. Contact support if you need access.',
  ACCOUNT_NOT_READY: 'Complete registration or contact support to continue.',
  PASSPORT_ONBOARDING_ONLY:
    'Complete Carrier Passport onboarding to use this feature.',
} as const;
